import Alignment from './Alignment'
import Angle from './Angle'
import Selection from './Selection'
import Size from './Size'
import Vector2 from './Vector2'
import Color from '../visuals/Color'

export default {
  [Alignment.className]: Alignment,
  [Angle.className]: Angle,
  [Selection.className]: Selection,
  [Size.className]: Size,
  [Vector2.className]: Vector2,
  [Color.className]: Color,
}
